import { postApi } from '@/util/request';
import s from './style.module.scss';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { setToken } from '@/util/tokenManager';
import { useAuth } from '@/stores/AuthContext';
import { useRouter } from 'next/router';
import { useStores } from '../../../../stores/storeContext';
import { useToast } from '@/stores/ToastContext';

export default function QrCode() {
  const { t } = useTranslation();
  const [codeImg, setCodeImg] = useState('');
  const [count, setCount] = useState(3); // 倒计时
  const { logged, login } = useAuth();
  const { rootStore } = useStores();
  const { setCurModal } = rootStore;
  const router = useRouter();
  const showToast = useToast();
  let tokenTimer;

  useEffect(() => {
    let timer;
    if (logged) {
      timer = setTimeout(() => {
        if (count <= 0) {
          router.push('/playground_mobile');
          clearTimeout(timer);
        } else {
          setCount((count) => count - 1);
        }
      }, 1000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [logged, count]);

  const webLogin = async (authToken) => {
    try {
      // 扫描二维码后，就可以通过 authToken 换取 accessToken 了
      const res = await postApi('/web/account/web-jwt-token', { authToken });
      if (res?.data?.token) {
        setCurModal(null);
        setToken(res.data.token); // 存到localStorage中，有效期24小时
        showToast(t('DUET_QR_CODE_SUCCESS_TOAST'));
        router.push('/playground_mobile');
        login();
      } else if (res?.meta?.code === 401000) {
        tokenTimer = setTimeout(async () => {
          await webLogin(authToken);
        }, 2000);
      } else if (res?.meta?.code === 40045) {
        showToast(t('DUET_QR_CODE_GAGAL_TOAST'));
        // 放弃等待登录结果
      }
    } catch (error) {
      showToast(t('DUET_QR_CODE_GAGAL_TOAST'));
      console.error(error);
    }
  };

  useEffect(() => {
    const getAuthToken = async () => {
      const res = await postApi('web/account/auth', { authType: 'qrCode' });
      const { authToken } = res.data;
      const imgStr = await QRCode.toDataURL(authToken || 'aaa');
      setCodeImg(imgStr);
      webLogin(authToken);
    };
    getAuthToken();

    return () => {
      if (tokenTimer) {
        clearTimeout(tokenTimer);
      }
    };
  }, []);

  return (
    <div>
      <div className={s.two_code_wrapper}>
        <img className={s.code_img} src={codeImg} alt="" />
      </div>
      <div className={s.code_title}>{t('DUET_NEW_LOGIN_CODE_TITLE')}</div>
      <div className={s.code_content}>{t('DUET_NEW_LOGIN_CODE_SUBTITLE')}</div>
    </div>
  );
}
